import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import {UmpireClub} from '@tisa-group/models';
import {ImageVariantPipe} from '@tisa-group/core';

@Component({
  selector: 'tisa-club-tile',
  templateUrl: './club-tile.component.html',
  styleUrls: ['./club-tile.component.scss'],
  providers: [ImageVariantPipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ClubTileComponent {
  @Input() club: UmpireClub | undefined;

  @Output() readonly clubClicked = new EventEmitter<UmpireClub>();

  get backroundImage(): string {
    if (!this.club) {
      return '';
    }

    return `url("${this.imageVariantPipe.transform(this.club.background_photo, {
      width: 600,
      height: 200,
      quality: 50,
    })}")`;
  }

  constructor(readonly imageVariantPipe: ImageVariantPipe) {}
}
